/* eslint-disable no-nested-ternary */
/* eslint-disable @next/next/no-img-element */
import ExternalIcon from '@assets/icons/external.svg'
import Lexus24Hour from '@assets/icons/lexus24hour.svg'
import Toyota24Hour from '@assets/icons/toyota24hour.svg'
import { CTA } from '@components/ui'
import { useBrand, useModel } from '@contexts/index'
import { getModelImage, tracking } from '@utils/helpers'
import { formEvent, updateDatalayer } from '@utils/helpers/tracking'
import { useEffect, useState } from 'react'

const Card = ({ model, setModel, isChecked, checkedModel, type }) => {
  const brand = useBrand()
  const modelString = useModel()
  const fuel = model?.filters?.fuel || undefined
  const [isTestDrive, setIsTestDrive] = useState(false)

  const img = getModelImage(
    brand,
    model?.image?.id,
    model?.image?.grade,
    model?.image?.color,
    null,
    model?.image?.fallback,
  )

  const imgWebp = getModelImage(
    brand,
    model?.image?.id,
    model?.image?.grade,
    model?.image?.color,
    'webp',
    model?.image?.fallback,
  )

  const Label = () => {
    if (!fuel) {
      return null
    }

    for (let i = 0; i < fuel.length; i += 1) {
      if (
        brand === 'toyota' &&
        (fuel[i] === undefined ||
          fuel[i].toLowerCase() === 'petrol' ||
          fuel[i].toLowerCase() === 'diesel')
      ) {
        return null
      }
      if (fuel[i] === undefined || fuel[i].toLowerCase() === 'diesel') {
        return null
      }
    }
    return (
      <span
        className={`${
          brand === 'lexus' ? '' : 'text-blue font-medium'
        } uppercase `}
      >{`${
        brand === 'toyota'
          ? `${fuel[0]}`
          : `${fuel[0]} ${fuel[1] ? `& ${fuel[1]}` : ''}`
      }`}</span>
    )
  }

  useEffect(() => {
    if (window.location.pathname === '/test-drive') {
      setIsTestDrive(true)
    }
    if (window.location.pathname === '/brochure') {
      setIsTestDrive(false)
    }
  }, [])

  useEffect(() => {
    if (isChecked) {
      updateDatalayer('model', { name: model.name, id: model.image.id })
    } else {
      updateDatalayer('model', false)
    }
  }, [isChecked])

  useEffect(() => {
    if (
      (modelString &&
        model.rangecode.toLowerCase() === modelString.toLowerCase()) ||
      model.name.toLowerCase() === modelString.toLowerCase() ||
      model.image.id.toLowerCase() === modelString.toLowerCase()
    ) {
      if (type === 'brochure') {
        checkedModel(model.rangecode)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modelString, model])

  const holdClasses =
    model.hold && type !== 'brochure' ? 'opacity-50 cursor-default' : ''
  const checkedOpacity = 'opacity-0'
  const checkedColour = isChecked && brand === 'lexus' ? 'bg-primary' : ''
  const checkedClasses = isChecked ? checkedOpacity : ''

  return (
    <label
      htmlFor={`input-${model.rangecode}`}
      className={`${
        model?.ui?.hidden ? ' hidden ' : ''
      } ${checkedColour} relative group min-h-[240px] h-full w-full flex flex-col justify-between cursor-pointer px-5 py-4 pb-3 border border-base`}
    >
      <div className="flex justify-between flex-row-reverse">
        <input
          id={`input-${model.rangecode}`}
          type="checkbox"
          className={`  rounded border-base text-base-text w-5 h-5 ml-6 mt-1 focus:border-blue focus:ring focus:ring-offset-0 focus:ring-blue group-checked:border-base ${
            type !== 'brochure' ? ' invisible ' : ''
          }`}
          checked={isChecked}
          onChange={(e) => {
            checkedModel(e.target.checked && model.rangecode)
            if (!model.hold && type !== 'brochure') {
              setModel(model)
              updateDatalayer('model', {
                name: model.name,
                id: model.image.id,
              })
            }
          }}
          data-gt-componentgroup={tracking.componentGroup()}
          data-gt-componentname={tracking.componentName()}
          data-gt-name="componentevent"
          data-gt-action="model-grid-click-model"
          data-gt-label={model.name}
        />
        <div
          className={`${
            model.hold && type !== 'brochure' ? 'opacity-50' : ''
          } ${isChecked ? 'opacity-50' : ''}`}
        >
          <p className="text-lg font-medium">{model.name}</p>
          <Label />
        </div>
      </div>
      {isTestDrive ? (
        <div>
          {brand === 'lexus' ? (
            model.all_day_test_drive === true ? (
              <div className="absolute top-3 right-4">
                <Lexus24Hour />
              </div>
            ) : null
          ) : model.all_day_test_drive === true ? (
            <div className="absolute top-3 right-4">
              <Toyota24Hour />
            </div>
          ) : null}
        </div>
      ) : null}
      <picture>
        <source type="image/webp" srcSet={imgWebp} />
        <img
          src={img}
          loading="lazy"
          alt={model.name}
          className={`mt-5 mb-3 ${holdClasses} ${checkedClasses}`}
        />
      </picture>
      {isChecked && type === 'brochure' && (
        <div className="absolute top-0 left-0 h-full w-full">
          <div
            className={` ${
              brand === 'toyota'
                ? 'h-full flex md:mt-[75px] mt-[30px] md:justify-start justify-center flex-1 flex-col md:flex-col items-center px-5 md:pb-0 space-y-4 md:space-y-0 md:space-x-4'
                : 'h-full flex md:mt-[75px] mt-[30px] md:justify-start justify-center flex-1 flex-col md:flex-col items-center px-5 md:pb-0 space-y-4 md:space-y-0 md:space-x-4'
            }`}
          >
            {model?.brochure_hold && (
              <p className="test-base text-lg text-center py-4 w-2/3">
                This brochure is being updated
              </p>
            )}
            {!model?.isEmailHidden && !model.brochure_hold && (
              <CTA
                className="w-full justify-center !mx-4 !my-2"
                onClick={() => setModel(model)}
                data-gt-componentgroup={tracking.componentGroup()}
                data-gt-componentname={tracking.componentName()}
                data-gt-name="componentevent"
                data-gt-action="model-grid-click-cta"
                data-gt-label="Email"
              >
                <span className="mr-2 pointer-events-none">Email</span>
                {brand !== 'lexus' && (
                  <svg
                    width="14"
                    height="9"
                    viewBox="0 0 14 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="mt-[2px]"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M0.599609 0.9C0.599609 0.402944 1.00255 0 1.49961 0H12.4996C12.9967 0 13.3996 0.402943 13.3996 0.9V7.9C13.3996 8.39706 12.9967 8.8 12.4996 8.8H1.49961C1.00255 8.8 0.599609 8.39706 0.599609 7.9V0.9ZM1.39961 7.43431V1.40007L4.85687 3.97705L1.39961 7.43431ZM5.78245 3.61716C5.81548 3.65018 5.84152 3.68754 5.86058 3.72741L6.89844 4.50101L11.8637 0.8H1.93319L5.56202 3.50487C5.64272 3.51755 5.72027 3.55498 5.78245 3.61716ZM12.5996 1.24924L9.05638 3.89031L12.5996 7.43353V1.24924ZM8.40817 4.37347L7.13786 5.32034C7.06589 5.37399 6.98179 5.3998 6.89844 5.39966C6.81509 5.3998 6.73099 5.37399 6.65902 5.32034L5.50508 4.46022L1.96529 8H12.0347L8.40817 4.37347Z"
                      fill="currentColor"
                    />
                  </svg>
                )}
              </CTA>
            )}
            {!model.brochure_hold && (
              <a
                href={model.url}
                className={`${
                  brand === 'lexus'
                    ? 'font-semibold text-secondary text-sm'
                    : ''
                } w-full text-center underline !mx-4 !my-2 `}
                target="_blank"
                rel="noopener noreferrer"
                data-gt-name="downloadevent"
                data-gt-action="download"
                data-gt-label={model.url}
                onClick={() =>
                  formEvent({
                    name: 'brochure-downloads',
                    step: 'download',
                    conversion: 1,
                    variant: '',
                  })
                }
              >
                Download
                <ExternalIcon className={`ml-[5px] inline`} />
              </a>
            )}
            {model.pricelist_url && (
              <a
                className={`${
                  brand === 'lexus'
                    ? 'font-semibold text-secondary text-sm'
                    : ''
                } w-full text-center  underline !mx-4 !my-2 `}
                href={model.pricelist_url}
                data-gt-name="componentevent"
                target="_blank"
                data-gt-componentgroup={tracking.componentGroup()}
                data-gt-componentname={tracking.componentName()}
                data-gt-action="model-grid-click-cta"
                data-gt-label="price list view"
                rel="noreferrer"
              >
                View Price List
                <ExternalIcon className={`ml-[5px] inline`} />
              </a>
            )}
          </div>
        </div>
      )}
    </label>
  )
}

export default Card
